import styled from "react-emotion";

const InformationCard = styled("div")`
  border: 1px solid lightgrey;
  border-radius: 5px;
  padding: 5px;
  min-height: 30px;
  margin: 5px;
`;

export default InformationCard;


// WEBPACK FOOTER //
// ./src/elements/InformationCard.tsx